module.exports = __webpack_public_path__ + "img/korea.ba0651b8.jpg";